import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Community from "@/pages/Community";
import NewPost from "@/pages/NewPost";
import PostDetail from "@/pages/PostDetail";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";

function Shell() {
  const location = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let id;
    const raf = (time) => {
      lenis.raf(time);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <>
      <Nav />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/community" element={<Community />} />
        <Route path="/community/new" element={<NewPost />} />
        <Route path="/community/:postId" element={<PostDetail />} />
        <Route path="/u/:userId" element={<Profile />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="*" element={<Landing />} />
      </Routes>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <div className="grain min-h-screen bg-ink text-white">
      <BrowserRouter>
        <AuthProvider>
          <Shell />
          <Toaster theme="dark" position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
